document.addEventListener( 'DOMContentLoaded', () => {
  const sections = [
    '.e-stn--main-hero-banner', 
    '.e-stn--inner-page-banner', 
    '.e-stn--cta-blocks'
  ];
  const startLoop = () => {
    sections.forEach( ( section ) => {
      let interval;
      const buttons = document.querySelectorAll( `${section} .e-btn--round` );
      const duration = ( section == '.e-stn--cta-blocks' ) ? 2000 : 3000;
      if ( buttons.length === 0 ) return;
      const startInterval = ( buttons, activeIndex ) => {
        interval = setInterval( () => {
          buttons.forEach( ( btn, id ) => {
            btn.classList.remove( 'active' );
            btn.setAttribute( 'data-index', id );
          } ); // Remove active from all
          buttons[activeIndex].classList.add( 'active' ); // Add active to current button
          activeIndex = ( activeIndex + 1 ) % buttons.length; // Move to next button
        }, duration ); // Change every 3 seconds
      };

      const stopInterval = () => {
        clearInterval( interval );
        document.querySelector( `${section} .e-btn--round.active` ).classList.remove( 'active' );
      };

      buttons.forEach( button => {
        button.addEventListener( 'mouseenter', ( e ) => { 
          if( e.target.closest( '.e-crd' ) ) {
            return;
          }
          stopInterval();
        } ); // Stop on hover
        button.addEventListener( 'mouseleave', ( e ) => {
          if( e.target.closest( '.e-crd' ) ) {
            return;
          }
          e.target.classList.add( 'active' );
          let activeIndex = e.target.dataset['index'];
          startInterval( buttons, activeIndex );
        } ); // Resume on leave
      } );

      const ctaCards = document.querySelectorAll( `${section} .e-crd > a` );
      if( ctaCards.length > 0 ) {
        ctaCards.forEach( ( card, ind ) => {
          card.addEventListener( 'mouseenter', () => {
            stopInterval();
          } ); // Stop on hover
          card.addEventListener( 'mouseleave', () => {
            const activeBtn = card.querySelector( '.e-btn--round' );
            activeBtn.classList.add( 'active' );
            let activeIndex = ind;
            startInterval( buttons, activeIndex );
          } ); // Resume on leave
        } );
      }
      startInterval( buttons, 0 ); // Start the animation loop
    } );
  };
  startLoop();
} );
